/**
 * Atlas PM · 任务优先级（P6.45）
 *
 * 优先级取值固定为 1 高 / 2 中 / 3 低（与数据库 task.priority smallint DEFAULT 2 一致）。
 * 中文标签与徽章色调**只在本文件定义一次**，前后端一律引用，禁止各写一份映射表。
 */
/** 优先级枚举（1 高 / 2 中 / 3 低） */
export const TASK_PRIORITY = {
    HIGH: 1,
    MEDIUM: 2,
    LOW: 3,
};
/** 中文标签（单一数据源，前后端共用） */
export const TASK_PRIORITY_LABELS = {
    1: '高',
    2: '中',
    3: '低',
};
/**
 * 优先级 → 徽章色调。
 *
 * 高 → 玫红 alert（需要优先处理）
 * 中 → 中性 idle（默认档，绝大多数任务）
 * 低 → 中性 idle
 *
 * ⚠️ P6.45 修正：「中」原用 `warn`（琥珀），但状态徽章里
 *    `SUBMITTED`（已提交）/ `APPROVING`（审批中）也用 `warn`，
 *    而「中」是默认档（绝大多数任务都是中），
 *    会在详情头部形成两个同色琥珀徽章并列 ⇒ 用户无法区分状态与优先级。
 *    故「中」改用中性 `idle`；只有「高」保留醒目色。
 */
export const TASK_PRIORITY_TONES = {
    1: 'alert',
    2: 'idle',
    3: 'idle',
};
/** 安全取中文标签（空值/未知值回退到「中」） */
export function priorityLabel(p) {
    return (TASK_PRIORITY_LABELS[p ?? TASK_PRIORITY.MEDIUM] ??
        TASK_PRIORITY_LABELS[TASK_PRIORITY.MEDIUM] ??
        '');
}
/** 安全取徽章色调（空值/未知值回退到「中」） */
export function priorityTone(p) {
    return (TASK_PRIORITY_TONES[p ?? TASK_PRIORITY.MEDIUM] ??
        TASK_PRIORITY_TONES[TASK_PRIORITY.MEDIUM] ??
        'idle');
}
//# sourceMappingURL=task-priority.js.map